<div class="page">
  <pla-main-nav-chips></pla-main-nav-chips>
  <div class="content-container extended">
<!--    <div class="-ps-5 side-container mb-3">-->
<!--      <div class="pt-0 position-relative">-->
<!--        <pla-side-nav></pla-side-nav>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="center-content-container position-relative">-->
      <div
        class="px-0 px-md-1 py-0 me-0">
        <div>
          <!-- CONTENT -->
          <div class="w-100">
            <div>
              <div style="background: #E5F1EF" class="py-4 px-4 px-md-5">
                <h1 class="d-block h1 fw-bold text-start mb-4">Hi, We're PlateX</h1>
                <p class="fw-bolder fs-md-16 fs-mb-14 mb-4">
                  The private registration market is evolving — and PlateX is building the platform to power it.
                </p>
                <p class="fw-normal fs-md-16 fs-mb-14 mb-0">
                  Our passionate team builds intelligent search tools and scalable infrastructure that simplify how the
                  public browse and buy private plates—while giving dealers the visibility and reach to grow their
                  business.
                </p>
              </div>

              <div class="py-3  px-4 px-md-5 py-md-5 container-fluid rounded-3">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-8">
                    <p class="fw-normal fs-md-16 fs-mb-14 mb-4">
                      What was once a niche industry has become a multi-million-pound sector, driven by collectors,
                      investors, and those looking for a unique form of self-expression. But the path to finding the
                      right plate felt stuck in the past. Buyers are forced to trawl through multiple dealer sites,
                      social media listings, and auction platforms—without a clear view of the market or pricing.
                    </p>

                    <p class="fw-normal fs-md-16 fs-mb-14 mb-4">
                      Over the past 25 years, the DVLA has generated more than £2.5 billion in revenue from personalised
                      registrations. Meanwhile, the resale market—where value and competition are often greater—remains
                      disjointed. The lack of a centralised marketplace limits visibility, consistency, and buyer
                      confidence.
                    </p>

                    <p class="fw-bolder fs-md-16 fs-mb-14 mb-4">
                      PlateX solves that.
                    </p>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                    <img
                      src="https://cdn.platex.co.uk/pages/about-us/SQUARE_REVUELTO.jpg"
                      class="d-none d-md-block ms-auto me-0 ratio ratio-1x1 d-block w-100" style="max-width: 350px"/>
                    <img
                      src="https://cdn.platex.co.uk/pages/about-us/SQUARE_REVUELTO.jpg"
                      class="d-block d-md-none mx-auto d-block w-100"/>
                  </div>
                </div>
              </div>

              <div class=" px-4 px-md-5 container-fluid rounded-3">
                <div class="row">
                  <p class="fw-bolder fs-md-20 fs-mb-18 mb-4 mb-md-5 mt-3">
                    We're not just building a search engine. We're building a market that works better for everyone.
                  </p>
                </div>

                <div class="row">
                  <div class="col-12 col-md-6 col-lg-4 col-xl-5 order-1 order-md-0 ">
                    <!-- METRIC GRID-->
                    <div class="row mb-4 mb-md-0">
                      <div class="col-6 col-md-6 col-lg-12 col-xl-6 mb-3">
                        <div
                          class="ratio-square-except-lg">
                          <div
                            class="rounded-2 p-2 p-md-4 h-100 d-flex align-items-center justify-content-center flex-column text-center"
                            style="background: #F1F5FE">
                            <mat-icon class="mb-2 fs-md-28">&#xe149;</mat-icon>
                            <p class="my-0">
                            <span class="fw-bolder fs-md-18 fs-mb-16 d-block" style="color: inherit" *ngIf="plateCount"
                                  [appCountUp]="plateCount" [duration]="2000"></span>
                              <span class="d-block fw-normal fs-md-16 fs-mb-14 lh-sm">Registrations</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-6 col-md-6 col-lg-12 col-xl-6 mb-3">
                        <div
                          class="ratio-square-except-lg">
                          <div
                            class="rounded-2 p-2 p-md-4 h-100 d-flex align-items-center justify-content-center flex-column text-center"
                            style="background: #FEF9DC">
                            <mat-icon class="mb-2 fs-md-28">&#xeaf1;</mat-icon>
                            <p class="d-block my-0">
                            <span class="fw-bolder fs-md-18 fs-mb-16" style="color: inherit" *ngIf="plateCount"
                                  [appCountUp]="priceCount" [duration]="2000"></span>
                              <span class="fw-bolder fs-md-18 fs-mb-16" style="color: inherit"> Billion</span>
                            </p>
                            <span class="d-block fw-normal fs-md-16 fs-mb-14 lh-sm">Unique Prices</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-6 col-md-6 col-lg-12 col-xl-6 mb-3">
                        <div
                          class="ratio-square-except-lg">
                          <div
                            class="rounded-2 p-2 p-md-4 h-100 d-flex align-items-center justify-content-center flex-column text-center"
                            style="background: #E0EDEF">
                            <mat-icon class="mb-2 fs-md-28">&#xe8b6;</mat-icon>
                            <p class="my-0">
                            <span class="fw-bolder fs-md-18 fs-mb-16 d-block" style="color: inherit" *ngIf="searchesThisWeek"
                                  [appCountUp]="searchesThisWeek" [duration]="2000"></span>
                              <span class="d-block fw-normal fs-md-16 fs-mb-14 lh-sm">Searches this Week</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-6 col-md-6 col-lg-12 col-xl-6 mb-3">
                        <div
                          class="ratio-square-except-lg">
                          <div
                            class="rounded-2 p-2 p-md-4 h-100 d-flex align-items-center justify-content-center flex-column text-center"
                            style="background: #F9EBE2">
                            <mat-icon class="mb-2 fs-md-28">&#xeaf6;</mat-icon>
                            <p class="my-0">
                            <span class="fw-bolder fs-md-18 fs-mb-16 d-block" style="color: inherit" *ngIf="comparesToday"
                                  [appCountUp]="comparesToday" [duration]="2000"></span>
                              <span class="d-block fw-normal fs-md-16 fs-mb-14 lh-sm">Prices Compared Today</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-8 col-xl-7 order-0 order-md-1">
                    <p class="fw-normal fs-md-16 fs-mb-14 mb-4">
                      Our platform aggregates listings from trusted dealers, private sellers, and unissued DVLA stock.
                      It delivers the first true “one-stop” search experience for number plates, with side-by-side price
                      comparisons, intelligent search tools, and transparent market data. Just as <a
                      href="https://www.autotrader.co.uk/">AutoTrader</a> transformed
                      car buying and <a
                      href="https://www.rightmove.co.uk/">Rightmove</a> changed property search, PlateX is building the
                      infrastructure to help
                      private registrations mature into a more accessible and trusted asset class.
                    </p>

                    <p class="fw-normal fs-md-16 fs-mb-14 mb-4">
                      As private registration prices climb—over 15% of DVLA auction results exceed £5,000—the need for a
                      structured, transparent, and centralised marketplace becomes more pressing. PlateX supports this
                      market evolution by giving buyers clarity and giving dealers the infrastructure they need to reach
                      today’s more informed, high-intent consumers.
                    </p>

                    <p class="fw-normal fs-md-16 fs-mb-14 mb-4">
                      For buyers, this means smarter, faster decisions. For dealers, it offers access to a high-intent
                      audience and real-time performance data. PlateX levels the playing field, driving conversions
                      through visibility, relevance, and clarity.
                    </p>
                  </div>
                </div>
              </div>

              <div class="py-1 py-md-5"></div>

            </div>
          </div>
        </div>
      </div>
<!--    </div>-->
  </div>
  <pla-featured-blogs>
    <div title>
      <p class="fw-bold mb-2 text-decoration-none d-block text-dark">In Other News</p>
    </div>
  </pla-featured-blogs>
</div>
